import Head from "next/head";
import { AppBar } from "./AppBar";
import { BetaAlertOutlet } from "./BetaAlertOutlet";

export const AppLayout = ({ children }) => {
  return (
    <>
      <Head>
        <title>DWBeyond</title>
      </Head>
      <AppBar />
      <BetaAlertOutlet>{children}</BetaAlertOutlet>
    </>
  );
};
